var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloudUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.125 2a4.875 4.875 0 0 0-3.453 8.316.75.75 0 1 1-1.063 1.058 6.375 6.375 0 1 1 9.927-7.872 4.875 4.875 0 0 1 2.942 8.633.75.75 0 1 1-.956-1.156A3.375 3.375 0 0 0 12.375 5c-.423 0-.825-.22-1.047-.596A4.87 4.87 0 0 0 7.125 2M8.47 7.47a.75.75 0 0 1 1.06 0l3 3a.75.75 0 1 1-1.06 1.06L9.75 9.81v4.94a.75.75 0 0 1-1.5 0V9.81l-1.72 1.72a.75.75 0 0 1-1.06-1.06z",
  clipRule: "evenodd"
})));
export default SvgCloudUpload;